import script from "./CitasEnLinea.vue?vue&type=script&setup=true&lang=js"
export * from "./CitasEnLinea.vue?vue&type=script&setup=true&lang=js"

import "./CitasEnLinea.vue?vue&type=style&index=0&id=8bf1a3ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8bf1a3ae"]])

export default __exports__